import VcStyle from './components/vc-style'

export default VcStyle



// WEBPACK FOOTER //
// ./src/lib.js